<h2 mat-dialog-title>
  @if (!groupId) {
    {{ 'AUTOMATIONS.GROUPING.CREATE_GROUP' | translate }}
  } @else {
    {{ 'AUTOMATIONS.GROUPING.EDIT_GROUP' | translate }}
  }
</h2>

<mat-dialog-content class="groups-content">
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'AUTOMATIONS.GROUPING.GROUP_NAME' | translate }}</glxy-label>
    <input required [(ngModel)]="groupName" type="text" matInput [maxlength]="maxNameLength" />
    <glxy-hint align="end"> {{ groupName?.length || 0 }}/{{ this.maxNameLength }} </glxy-hint>
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'AUTOMATIONS.EDITOR.NOTES' | translate }}</glxy-label>
    <textarea matInput [(ngModel)]="groupNotes" [maxlength]="maxNotesLength"></textarea>
    <glxy-hint align="end"> {{ groupNotes?.length || 0 }}/{{ this.maxNotesLength }} </glxy-hint>
  </glxy-form-field>
</mat-dialog-content>

<mat-dialog-actions mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close data-action=”modal-cancel-group-clicked”>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button [disabled]="loading" (click)="save()" mat-flat-button color="primary" data-action=”modal-save-group-clicked”>
    <glxy-button-loading-indicator [isLoading]="loading">
      {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
